// extracted by mini-css-extract-plugin
export default {"btn-back":"RequiedLoginPopup_btn-back__+mJWb","btn-login":"RequiedLoginPopup_btn-login__52+8N"};